// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.video-slider {
  overflow: hidden;
  display: flex;
  /* justify-content: center; */
}

.slider-content {
  display: flex;
  animation: slideAnimation 100s infinite;
}

.slider-content:hover {
  animation-play-state: paused;
}

@keyframes slideAnimation {
  0% {
    transform: translateX(0);
  }
  100% {
    transform: translateX(-100%);
  }
}

.video-card {
  padding: 10px;
  transition: transform 0.9s ease;
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: 250px;
  max-height: 300px;
  min-width: 250px;
  min-height: 300px;
  border-radius: 20px;
  margin: 10px;
  outline: 1px solid lightgrey;
  overflow: hidden;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.video-card:hover {
  transform: scale(1.1);
}

.video-thumbnail {
  position: relative;
  cursor: pointer;
}

.video-thumbnail img {
  width: 100%;
  height: auto;
  max-width: 250px;
  min-width: 250px;
  border-radius: 20px;
}

.video-thumbnail::after {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  pointer-events: none;
  border-radius: 20px;
  background: linear-gradient(
    to bottom,
    rgba(0, 0, 0, 0.2) 0%,
    rgba(0, 0, 0, 0.1) 50%,
    rgba(0, 0, 0, 0) 100%
  );
}

.video-details {
  margin-top: 14px;
  text-align: center;
}

.video-details h3 {
  font-size: 16px;
  font-weight: bold;
  margin: 0;
}


@media (max-width: 768px) {
  .video-card {
    max-width: 300px;
    max-height: 240px;
    min-width: 100px;
    min-height: 140px;
  }

  .video-card:hover {
    transform: scale(1);
  }

  .video-thumbnail img {
    max-width: 200px;
    min-width: 200px;
  }
}`, "",{"version":3,"sources":["webpack://./src/FrontEnd/YouTube/YouTubeVideo.css"],"names":[],"mappings":";AACA;EACE,gBAAgB;EAChB,aAAa;EACb,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,uCAAuC;AACzC;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE;IACE,wBAAwB;EAC1B;EACA;IACE,4BAA4B;EAC9B;AACF;;AAEA;EACE,aAAa;EACb,+BAA+B;EAC/B,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,YAAY;EACZ,4BAA4B;EAC5B,gBAAgB;EAChB,wCAAwC;AAC1C;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,oBAAoB;EACpB,mBAAmB;EACnB;;;;;GAKC;AACH;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,SAAS;AACX;;;AAGA;EACE;IACE,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;IAChB,gBAAgB;EAClB;AACF","sourcesContent":["\n.video-slider {\n  overflow: hidden;\n  display: flex;\n  /* justify-content: center; */\n}\n\n.slider-content {\n  display: flex;\n  animation: slideAnimation 100s infinite;\n}\n\n.slider-content:hover {\n  animation-play-state: paused;\n}\n\n@keyframes slideAnimation {\n  0% {\n    transform: translateX(0);\n  }\n  100% {\n    transform: translateX(-100%);\n  }\n}\n\n.video-card {\n  padding: 10px;\n  transition: transform 0.9s ease;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  max-width: 250px;\n  max-height: 300px;\n  min-width: 250px;\n  min-height: 300px;\n  border-radius: 20px;\n  margin: 10px;\n  outline: 1px solid lightgrey;\n  overflow: hidden;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n}\n\n.video-card:hover {\n  transform: scale(1.1);\n}\n\n.video-thumbnail {\n  position: relative;\n  cursor: pointer;\n}\n\n.video-thumbnail img {\n  width: 100%;\n  height: auto;\n  max-width: 250px;\n  min-width: 250px;\n  border-radius: 20px;\n}\n\n.video-thumbnail::after {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  pointer-events: none;\n  border-radius: 20px;\n  background: linear-gradient(\n    to bottom,\n    rgba(0, 0, 0, 0.2) 0%,\n    rgba(0, 0, 0, 0.1) 50%,\n    rgba(0, 0, 0, 0) 100%\n  );\n}\n\n.video-details {\n  margin-top: 14px;\n  text-align: center;\n}\n\n.video-details h3 {\n  font-size: 16px;\n  font-weight: bold;\n  margin: 0;\n}\n\n\n@media (max-width: 768px) {\n  .video-card {\n    max-width: 300px;\n    max-height: 240px;\n    min-width: 100px;\n    min-height: 140px;\n  }\n\n  .video-card:hover {\n    transform: scale(1);\n  }\n\n  .video-thumbnail img {\n    max-width: 200px;\n    min-width: 200px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
